import { createFileRoute } from '@tanstack/react-router'
import { RateRolesSection } from '../../../features/projects/rates/rate-roles-section'
import { requireSection } from '../../../features/settings/guards'

export const Route = createFileRoute('/_app/settings/project-rate-roles')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'project-rate-roles'),
  component: RateRolesSection,
})
